/* eslint-disable import/prefer-default-export */
export const contentParser = (content) => {
  const parsedContent = []

  // Split content by tags
  const elements = content.split(/(<\/?[^>]+>)/g).filter(Boolean)

  elements.forEach((element) => {
    if (element.startsWith('<ul>')) {
      parsedContent.push(element)
    } else if (element.startsWith('<li>')) {
      parsedContent.push(element)
    } else if (element.startsWith('<p>')) {
      parsedContent.push(element)
    } else if (element.startsWith('</ul>')) {
      parsedContent.push(element)
    } else if (element.startsWith('</li>')) {
      parsedContent.push(element)
    } else if (element.startsWith('</p>')) {
      parsedContent.push(element)
    } else {
      // Handle text content
      parsedContent.push(element)
    }
  })

  return parsedContent.join('')
}
